<template>
  <el-dialog
    title="标签回收"
    :visible="visible"
    width="480px"
    :show-close="false"
    append-to-body
    :close-on-press-escape="false"
    :close-on-click-modal="false"
    @close="handleClose">
    <el-form
      ref="ruleForm"
      :model="info"
      label-width="110px">
      <el-form-item label="发放号段：">{{ options.min }}-{{ options.max }}</el-form-item>
      <el-form-item
        label="开始序号："
        prop="beginTagNo">
        <el-input-number
          v-model="info.beginTagNo"
          style="width: 100%"
          :max="options.max"
          :min="options.min"
          :precision="0"></el-input-number>
      </el-form-item>
      <el-form-item
        label="结束序号："
        prop="endTagNo">
        <el-input-number
          v-model="info.endTagNo"
          style="width: 100%"
          :max="options.max"
          :min="options.min"
          :precision="0"></el-input-number>
      </el-form-item>
      <el-form-item
        label="鉴定中心："
        prop="destRoomId">
        <room-select
          v-model="info.destRoomId"
          :clearable="true"
          style="width: 100%"
          :showAll="false" />
      </el-form-item>
    </el-form>
    <el-alert
      title="开始序号为空时默认取发放记录起始序号；结束序号为空时默认取发放记录结束序号；鉴定中心有值时表示回收的标签重新发放给该鉴定中心"
      type="warning"
      :closable="false" />
    <span slot="footer">
      <el-button
        :loading="loading"
        @click="visible = false">取 消</el-button>
      <el-button
        type="primary"
        :loading="loading"
        @click="handleSubmit">确 定</el-button>
    </span>
  </el-dialog>
</template>
<script>
import AppraiseLable from '../../../../service/appraiseLable'
import RoomSelect from '../../room-select.vue'
export default {
  name: 'LabelRecycleModal',
  components: { RoomSelect },
  data() {
    return {
      loading: false,
      visible: false,
      info: { tagAssignId: null, beginTagNo: undefined, endTagNo: undefined, destRoomId: null },
      options: { min: 0, max: 0 }
    }
  },
  methods: {
    handleClose() {
      this.info = { tagAssignId: null, beginTagNo: undefined, endTagNo: undefined, destRoomId: null }
    },
    handleSubmit() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          const { beginTagNo, endTagNo, destRoomId } = this.info
          if (endTagNo < beginTagNo) {
            this.$message.error('结束序号不能小于开始序号')
            return
          }
          const msg = `是否确认回收该段标签${destRoomId ? '到所选鉴定中心' : ''}？`
          this.$confirm(msg, '提示', { confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning' })
            .then(() => {
              this.recycletagassign()
            })
        }
      })
    },
    recycletagassign() {
      this.loading = true
      AppraiseLable.recycletagassign({ ...this.info })
        .then(res => {
          this.loading = false
          const { result, message } = res.data
          if ([0].includes(result)) {
            this.$message.success('回收成功')
            this.visible = false
            this.$emit('success')
          } else {
            this.$message.error(message)
          }
        })
        .catch(err => {
          this.loading = false
          this.$message.error(err.message)
        })
    },
    init({ tagAssignId, minTagNo, maxTagNo }) {
      this.info.tagAssignId = tagAssignId
      this.options.min = minTagNo
      this.options.max = maxTagNo
      this.info.beginTagNo = minTagNo
      this.info.endTagNo = maxTagNo
      this.info.destRoomId = null
      this.visible = true
    }
  }
}
</script>
